var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"no-styling":""}},[_c('div',[_c('dashboard-data',{staticClass:"card pa0"}),_c('div',{staticClass:"card-spacing"}),_c('campaign-carousel')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }